import { Competence } from "../Types/Competence";
import { Lang } from "../Types/Lang";

type Props = {
  propList: Competence[];
  lang: Lang;
  title: string;
};

const CompetenceComponent = ({ propList, lang, title }: Props) => {
  return (
    <section className="cv-section">
      <div className="cv-card space-y-5">
        <h2 className="cv-heading">{title}</h2>

        <ul className="grid gap-4">
          {propList.map((c, i) => (
            <li
              key={i}
              className="border border-brand-soft/70 bg-brand-soft/10 p-4 shadow-sm"
            >
              <h3 className="cv-subheading">{c.name}</h3>
              <p className="cv-text text-sm">{c.description[lang]}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CompetenceComponent;
